import { render, staticRenderFns } from "./recipient-dropdown.vue?vue&type=template&id=24dc1d76&scoped=true&"
import script from "./recipient-dropdown.vue?vue&type=script&lang=js&"
export * from "./recipient-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./recipient-dropdown.vue?vue&type=style&index=0&id=24dc1d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc1d76",
  null
  
)

export default component.exports